import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UiCoreModule } from '@softline/ui-core';
import { PersonalUebersicht } from '../../types/abteilung';

@Component({
  selector: 'soft-mitarbeiter-card',
  imports: [CommonModule, UiCoreModule],
  templateUrl: './mitarbeiter-card.component.html',
  styleUrls: ['./mitarbeiter-card.component.scss'],
})
export class MitarbeiterCardComponent implements OnInit {
  @Input() mitarbeiter!: PersonalUebersicht;
  @Input() selected = false;
  @Input() mode: 'selection' | 'display' = 'display';
  @Output() tapped = new EventEmitter<void>();

  constructor() {
    //
  }

  ngOnInit(): void {
    //
  }
}
